import { useEffect } from "react";
import { ToggleButton } from "components";
import { useInput } from "hooks";
import { LabelledSelect } from "../../../../Fields";

export const IncentiveDownloadTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const free = useInput(false);
  const day = useInput("");
  const dayData = [
    { value: "", label: "None" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" },
  ];

  const handleUpdateValue = (isFree, type) => {
    onChange(`${isFree ? "Free " : ""}${type} Download`);
  };

  useEffect(() => {
    if (value.endsWith("Download")) {
      let main = value.slice(0, -8);
      if (main.startsWith("Free")) {
        main = main.slice(4).trim();
        free.setValue(true);
      } else {
        free.setValue(false);
      }
      const parts = main.split(" ");
      day.setValue(parts[0].trim());
    }
    return () => { };
  }, [value]);

  return (
    <div className="p-2 d-flex justify-content-between align-items-center">
      <ToggleButton
        className="mt-3 mr-3"
        label="Free"
        {...free}
        value={free.value}
        onChange={(e) => {
          free.setValue(e);
          handleUpdateValue(e, day.value);
        }}
      />

      <LabelledSelect label="Type" style={{ width: '90%' }}
        options={dayData} value={day.value}
        onChange={(e) => {
          day.setValue(e);
          handleUpdateValue(free.value, e);
        }} />

      <div className="mt-3">Download</div>
    </div>
  );
};